var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEditEnabled = function SvgIconEditEnabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979AAF",
    d: "M16.378 14.839c.344 0 .622.272.622.608 0 .336-.278.609-.622.609H.622c-.344 0-.622-.273-.622-.609 0-.336.278-.608.622-.608h15.756zm-.007-11.035l-9.87 9.656-3.848.385.393-3.764 8.583-8.397 1.288-1.26c.579-.566 1.588-.566 2.167 0l1.287 1.26c.288.28.45.663.45 1.06 0 .4-.16.777-.45 1.06zM4.046 12.482l1.888-.188 7.83-7.66-1.695-1.659-7.83 7.66-.193 1.847zM14 1.202c-.076 0-.15.03-.204.083l-.848.83 1.696 1.658.847-.83c.113-.11.113-.288 0-.398l-1.287-1.26c-.054-.053-.127-.083-.204-.082z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEditEnabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit-enabled.a68d0409.svg";
export { ForwardRef as ReactComponent };